export default __webpack_public_path__ + "static/media/Leg Upper Left.e8adb9b1.jpg";